<template>

  <section class="container visible" id="viewcontact">

    <div class="backbutton">
      <div class="columns flex alignMiddle">
        <div class="column grow">
            <a href="#!" class="button" v-on:click="goBack">Zurück</a>
        </div>
      </div>
    </div>
  
    <div class="columns flex alignTop ">
      <div class="column half ">
    
            <div id="companyname" class="columns small-flex spacebetween">
              <div class="column"><div class="icon icon-contacts2"></div></div>
              <div class="column grow"><strong>{{firstname}} {{lastname}}</strong></div>
              <div class="column right"><router-link v-if="slug" v-bind:to="{ name: 'EditContact', params: { contact: slug }}" class="icon icon-edit">edit</router-link></div>
            </div>
            
            
            <div id="companyaddress_box" class="columns small-flex box alignTop" v-if=" education || position || department ">
              <div class="column"><div class="icon icon-user"></div></div>
              <div id="companyaddress" class="column">
                   <span class="block">
                  Ausbildung: {{education}} <br>
                  Position: {{position}}
                  <span v-if="department"><br>Abteilung: {{department}}</span>
                  </span>
              </div>
            </div>
            
            <div id="companyaddress_box" class="columns small-flex box alignTop" v-if=" address || zipcode || city || country ">
              <div class="column"><div class="icon icon-location"></div></div>
              <div id="companyaddress" class="column">
                <span class="block">
                  <span v-if="address">{{address}}<br></span>
                <span v-if="zipcode || city">{{zipcode}} {{city}}<br></span>
                {{country}}
                </span>
              </div>
              
            </div>

            <div class="columns small-flex fewerpadding" v-if="phonenumber">
              <div class="column"><div class="icon icon-phone"></div></div>
              <div id="companyphonenumber" class="column">
                <a v-if="phonenumber" :href="'tel:'+ formatTel(phonenumber)">{{phonenumber}}</a>
              </div>
              
            </div>

            <div class="columns small-flex fewerpadding" v-if="mobile">
              <div class="column"><div class="icon icon-mobile"></div></div>
              <div id="companyphonenumber" class="column">
                <a v-if="mobile" :href="'tel:'+ formatTel(mobile)">{{mobile}}</a>
              </div>              
            </div>
            
            <div class="columns small-flex fewerpadding" v-if="emailaddress">
              <div class="column"><div class="icon icon-send"></div></div>
              <div id="emailaddress" class="column">
                <a :href="'mailto:' + emailaddress">{{emailaddress}}</a>
              </div>
            </div>

            <div class="columns small-flex fewerpadding" v-if="website">
              <div class="column"><div class="icon icon-website"></div></div>
              <div id="companywebsite" class="column">
                <a :href="companywebsite_link(website)" target="_blank">{{website}}</a>
              </div>
            </div>
    
      </div>
      <div class="column half ">
          
          
          
<!--
          <div class="staff-list" v-for="(company, i) in relatedcompany" :key="i" >           

          <div id="kontakte" class="columns small-flex spacebetween">
              <div class="column"><div class="icon icon-contacts2"></div></div>
            <div class="column grow"><strong>{{company.company}}</strong></div>
            <div class="column right "><router-link v-bind:to="{ name: 'ViewCompany', params: { contact: company.slug }}" class="icon icon-chevron-right">edit</router-link></div>
            
          </div>

            <div id="companyaddress_box" class="columns small-flex box alignTop">
              <div class="column"><div class="icon icon-location"></div></div>
              <div id="companyaddress" class="column">
                <span class="block">{{company.companyaddress}}<br>
                {{company.companyzipcode}} {{company.companycity}}<br>
                {{company.companycountry}}
                </span>
              </div>
              
            </div>

           
            <div class="columns small-flex  fewerpadding alignTop" v-if="company.companyphonenumber">
              <div class="column"><div class="icon icon-phone"></div></div>
              <div class="column grow">
                  <span class="block" ><a :href="'tel:' + formatTel(company.companyphonenumber)">{{company.companyphonenumber}}</a></span>
              </div>              
            </div>

            <div class="columns small-flex fewerpadding alignTop" v-if="company.companyfaxnumber">
              <div class="column"><div class="icon icon-fax"></div></div>
              <div class="column grow">
                  <span class="block" ><a :href="'tel:' + formatTel(company.fax)">{{company.companyfaxnumber}}</a></span>
              </div>              
            </div>
            
            <div class="columns small-flex fewerpadding alignTop" v-if="company.companyemailaddress">
              <div class="column"><div class="icon icon-send"></div></div>
              <div class="column grow">
                  <span class="block" ><a :href="'mailto:'+company.emailaddress">{{company.companyemailaddress}}</a></span>                
              </div>              
            </div>            

            
         </div>
-->
      </div>      
      
      
      
    </div>
    
    <div class="columns flex alignTop wrap spacebetween ">
      <div class="column textLeft grow">
        <div class="columns borderTop">
          <div class="column">
           Geburtstag: {{birthday}}
          </div>
          <div class="column">
           PA-Nr: {{panr}}
          </div>
          <div class="column">
           KK: {{kk}}
          </div>
          <div class="column">
           Vers-Nr.: {{versnr}}
          </div>
        </div>
        <div class="columns flex wrap borderTop">          
          <div class="column" v-if="engl">
           Englisch<i class="iconn icon-ok"></i>
          </div>
          <div class="column" v-if="eh == true">          
            EH <i class="iconn icon-ok"></i>
          </div>
          <div class="column" v-if="sibe == true">
           Sibe <i class="iconn icon-ok"></i>
          </div>
          <div class="column" v-if="stapler == true">
           Stapler <i class="iconn icon-ok"></i>
          </div>
          <div class="column" v-if="kran == true">
           Kran <i class="iconn icon-ok"></i>
          </div>
          <div class="column" v-if="sivv == true">
           Sivv <i class="iconn icon-ok"></i>
          </div>
          <div class="column" v-if="winde == true">
           Winde <i class="iconn icon-ok"></i>
          </div>
          <div class="column" v-if="dat == true">
           DAT <i class="iconn icon-ok"></i>
          </div>
          <div class="column" v-if="hoehent == true">
           Hoehent <i class="iconn icon-ok"></i>
          </div>
        </div>
        <div class="columns flex borderTop">
          <div class="column">
           Spritzen: {{spritzen}}<br>
          </div>
          <div class="column">
           Mauern: {{mauern}}<br>
          </div>
          <div class="column">
           Faser: {{faser}}</span>
          </div>
        </div>
      </div>
    </div>
    
  </section>
  
</template>
<script>
import firebase from 'firebase'
  
export default {
  name: 'ViewContact',
  data: function(){ 
    return {
      
          edit: false,

          relatedcompany: [],
/*
          company: {
            companyphonenumber:null,
            company:null,
            slug:null,
            companyemailaddress:null,
            companywebsite:null,
            companyaddress:null,
            companyfaxnumber:null,
            companycountry: null,
            companyzipcode:null,
          },
*/
          
          staff: [],
          companyid: null,          
          slug: null,
          firstname : null,
          lastname : null,
          education : null,
          position : null,
          department : null,
          emailaddress : null,
          phonenumber : null,
          mobile : null,
          zipcode : null,
          city : null,
          address : null,
          country : null,
          birthday : null,
          panr : null,
          kk : null,
          versnr : null,
          eh : null,
          sibe : null,
          stapler : null,
          kran : null,
          sivv : null,
          winde : null,
          dat : null,
          hoehent : null,
          spritzen : null,
          mauern : null,
          faser : null,
          engl : null,
          website: null
     
    }
  },
  
/*
  beforeRouteEnter (to, from, next) {
      firebase.firestore().collection('contacts').where('slug', '==', to.params.contact).get().then((querySnapshot) => {
      console.log('beforeRouteEnter');
        querySnapshot.forEach((doc) => {
          next(vm => {
            vm.firstname = doc.data().firstname
            vm.lastname = doc.data().lastname
            vm.emailaddress = doc.data().emailaddress
            vm.phonenumber = doc.data().phonenumber
          })
        })
      })
    },
*/
  
  mounted: function(){
      this.fetchData();
  },
  methods: {
    
    goBack: function(e){
      e.preventDefault();
      this.$router.go(-1)
    },
      
      formatTel: function(tel){
        if(tel && tel !="")
        return tel.replace(/[`~!@#$%^&*()_|\-=?;:'",.<>\{\}\[\]\\\/ ]/gi, '').replace('+490', '+49');
      },
      companywebsite_link: function(companywebsite) {
        if(companywebsite && companywebsite !="")
        return ( companywebsite.toLowerCase().indexOf('http://') > -1 || companywebsite.toLowerCase().indexOf('http://' ) > -1 ? companywebsite : 'http://'+companywebsite)
      },
      
      
      
    
      fetchData : function () {
        console.log('fetching data');
        firebase.firestore().collection('contacts').where('slug', '==', this.$route.params.contact).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            console.log(doc.data() );
            
            this.companyid = doc.data().companyid
            this.slug = doc.data().slug
            this.firstname = doc.data().firstname
            this.lastname = doc.data().lastname
            this.education = doc.data().education
            this.position = doc.data().position
            this.department = doc.data().department
            this.emailaddress = doc.data().emailaddress
            this.phonenumber = doc.data().phonenumber
            this.mobile = doc.data().mobile
            this.zipcode = doc.data().zipcode
            this.city = doc.data().city
            this.address = doc.data().address
            this.country = doc.data().country
            
            this.birthday = doc.data().birthday
            
            this.panr = doc.data().panr
            this.kk = doc.data().kk
            this.versnr = doc.data().versnr
            
            this.eh = doc.data().eh == true ? true : false
            this.sibe = doc.data().sibe == true ? true : false
            this.stapler = doc.data().stapler == true ? true : false
            this.kran = doc.data().kran == true ? true : false
            this.sivv = doc.data().sivv == true ? true : false
            this.winde = doc.data().winde == true ? true : false
            this.dat = doc.data().dat == true ? true : false
            this.hoehent = doc.data().hoehent == true ? true : false
            this.engl = doc.data().engl == true ? true : false

            this.spritzen = doc.data().spritzen
            this.mauern = doc.data().mauern
            this.faser= doc.data().faser
          })
        
         })

        
      },
      getCompany : function() {
        firebase.firestore().collection('contacts').where('slug', '==', this.companyid ).get().then((querySnapshot) => {
                querySnapshot.forEach((doc2) => {
                  console.log( doc2.data() );
                  this.relatedcompany.push( doc2.data() );
         })})   
      }
      
  
    },
    watch: {
      companyid: function(oldvalue, newvalue){
        console.log('get Company');
        this.getCompany()
      }
    }
} 
</script>
<style>
  
  #viewcontact { padding: 5rem 0 0 0; }
  #viewcontact .columns .column .textLeft { text-align: left !important; }
  #viewcontact .field { display: flex; padding: 0; }
  #viewcontact .control { padding: 0.43333333em; display: flex; }
  #viewcontact .control-50 { flex: 1 1 50%; width: 50%; max-width: 50%; }
  #viewcontact .control-100 { flex: 0 0 100%; width:100%; max-width: 100%; align-items: stretch; }
  #viewcontact .control input[type=text] { width: 100%; margin: 0; }
  #viewcontact .control input[type=email] { width: 100%; margin: 0; }
  #viewcontact .control input { border-radius: 0 3px 3px 0; }
  #viewcontact .input-icon { display: inline-block; height: 48px; width: 48px; min-width: 48px; border-radius: 3px 0 0 3px; line-height: 48px; }
  #viewcontact .control input { order: 2; }
  #viewcontact .control input-icon { order: 1; }
  #viewcontact .control input:focus + .input-icon { border-color: #00aeff; }

  #viewcontact span.block { display: block; padding: 0.233333em 0}

  #viewcontact .icon-company { background: url(../assets/icons/disc.svg) center center no-repeat; background-size: 1.6333333em;  text-indent: -9999px; }
  #viewcontact .icon-fax { background: url(../assets/icons/print.svg) center center no-repeat; background-size: 1.6333333em;  text-indent: -9999px; }
  #viewcontact .icon-flag { background: url(../assets/icons/flag.svg) center center no-repeat; background-size: 1.6333333em;  text-indent: -9999px; }

  #viewcontact .icon-mobile { background: url(../assets/icons/iphone.svg) center center no-repeat; background-size: 1.6333333em;  text-indent: -9999px; }
  #viewcontact .icon-flag { background: url(../assets/icons/flag.svg) center center no-repeat; background-size: 1.6333333em;  text-indent: -9999px; }

  #viewcontact .icon { display: inline-block; background: #fff; height: 1.6333333em; width: 1.6333333em; min-width: 1.6333333em; border-radius: 0; line-height: 1.6333333em; }
  #viewcontact .icon-location { background: url(../assets/icons/location.svg) center top no-repeat; background-size: 1.8333333em; }
  #viewcontact .icon-phone { background: url(../assets/icons/phone.svg) center center no-repeat; background-size: 1.6333333em; }
  #viewcontact .icon-mobile { background: url(../assets/icons/iphone.svg) center center no-repeat; background-size: 1.6333333em; }
  #viewcontact .icon-fax { background: url(../assets/icons/print.svg) center center no-repeat; background-size: 1.6333333em; }
  #viewcontact .icon-send { background: url(../assets/icons/envelope-alt.svg) center center no-repeat; background-size: 1.6333333em; }
  #viewcontact .icon-edit { background: url(../assets/icons/edit.svg) center center no-repeat; background-size: 1.6333333em; text-indent: -9999px; }
  #viewcontact .icon-website { background: url(../assets/icons/home-alt.svg) center center no-repeat; background-size: 1.6333333em; }

  #viewcontact .icon-user { background:  url(../assets/icons/user.svg) center center no-repeat; background-size: 1.6333333em; }

  #viewcontact .icon-chevron-right { background: url(../assets/icons/chevron-right.svg) center center no-repeat; background-size: 1.633333333em; text-indent: -9999px; }
  #viewcontact .icon-chevron-right:hover { background: url(../assets/icons/chevron-right.svg) center center no-repeat; background-size: 1.63333333em; }

  #viewcontact .iconn { display: inline-block; height: 16px; width: 16px; min-width: 16px; border-radius: 3px 0 0 3px; line-height: 16px; margin-left: 0.13333em; }
  #viewcontact .iconn.icon-ok { background:  url(../assets/icons/ok.svg) center center no-repeat; background-size: 1.6333333em; }


  #viewcontact .control .iconafter#newcompany { display: inline-block; height: 48px; width: 48px; min-width: 48px; border: 0; line-height: 48px; order: 3; text-indent: -9999px; background: url(../assets/icons/add.svg) center center no-repeat; background-size: 1.6333333em; text-indent: -9999px; }


  #viewcontact #viewcompany { height: auto; overflow: hidden; opacity: 0; width: 100%; max-height: 0; transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out; cursor: pointer; }
  #viewcontact .visible #viewcompany { max-height: 600px; opacity: 1; }
  #viewcontact .visible .control .iconafter#viewcompany { background: url(../assets/icons/remove.svg) center center no-repeat; background-size: 1.6333333em; }
  
  #viewcontact .column.right { width: 2.13333333em; align-items: flex-end;  }
  
  #viewcontact .fewerpadding .column { padding: 0.22222em 0.9333333em !important; }

  #viewcontact .columns.borderTop { border-top: 1px solid #ddd !important; }
  
  #viewcontact .column.fewerpadding { padding: 0.22222em 0.9333333em !important; }


  #viewcontact .column.grow { flex-grow: 1; text-align: left; }
  #viewcontact .box { padding: 0.93333333em 0 0; }  
  
  #viewcontact #companyname { border-bottom: 1px solid #ddd; }
  #viewcontact #companyname .icon { height: 1.6333333em; width: 1.6333333em; min-width: 1.444em; border-radius: 0; line-height: 1.6333333em; }
  #viewcontact #companyname .column { padding: 0.33333rem 0.9333333em 0.11em }
  #viewcontact #kontakte { border-bottom: 1px solid #ddd; }
  #viewcontact #kontakte .column { padding: 0.33333rem 0.9333333em 0.11em; }
  #viewcontact .icon-contacts2 { background: url(../assets/icons/contact-book.svg) center center no-repeat; background-size: 1.6333333em; height: 1.444rem; width: 1.6333333em; min-width: 1.6333333em; border-radius: 0; line-height: 1.6333333em; padding: 0 !important; }
  #viewcontact #kontakte .icon-contacts2 { background: url(../assets/icons/contact-book.svg) center center no-repeat; background-size: 1.6333333em; height: 1.6333333em; width: 1.6333333em; min-width: 1.444em; border-radius: 0; line-height: 1.444rem; padding: 0 !important; }
  
  #viewcontact .box { text-align: left; }
  
/*   #viewcontact .column { border: 1px solid red; } */
  
  
</style>


// WEBPACK FOOTER //
// src/components/ViewContact.vue